import { create } from 'zustand';

const useStore = create((set, get) => ({
  user: null,
  token: localStorage.getItem('token'),
  botStatus: null,
  settings: {},
  dashboardData: null,
  marketData: { NIFTY: null, BANKNIFTY: null },
  openPositions: [],
  notifications: [],

  setUser: (user) => set({ user }),
  setToken: (token) => {
    localStorage.setItem('token', token);
    set({ token });
  },
  logout: () => {
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  setBotStatus: (botStatus) => set({ botStatus }),
  setSettings: (settings) => set({ settings }),
  setDashboardData: (dashboardData) => set({ dashboardData }),
  setMarketData: (symbol, data) => set((state) => ({
    marketData: { ...state.marketData, [symbol]: data },
  })),
  setOpenPositions: (openPositions) => set({ openPositions }),
  addNotification: (notification) => set((state) => ({
    notifications: [notification, ...state.notifications].slice(0, 50),
  })),
}));

export default useStore;
